var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfaceTourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3966_9342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#626262"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3966_9342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01749 17.9168C8.59652 17.9168 8.19853 17.8282 7.82353 17.6508C7.44853 17.4734 7.13499 17.2186 6.8829 16.8864L2.6377 11.3879L2.9454 11.0596C3.15374 10.8373 3.4029 10.7038 3.6929 10.6589C3.9829 10.6139 4.2545 10.6689 4.5077 10.8239L6.53832 11.9137V5.3208C6.53832 5.14372 6.59825 4.99524 6.71811 4.87538C6.83783 4.75566 6.98631 4.6958 7.16353 4.6958C7.34075 4.6958 7.49131 4.75566 7.6152 4.87538C7.73908 4.99524 7.80103 5.14372 7.80103 5.3208V14.1204L5.29936 12.7581L7.89874 16.146C8.03554 16.318 8.20221 16.4477 8.39874 16.5354C8.5954 16.623 8.80165 16.6668 9.01749 16.6668H13.1167C13.6392 16.6668 14.0837 16.485 14.4502 16.1212C14.8166 15.7573 14.9998 15.3142 14.9998 14.7918V11.6508C14.9998 11.3647 14.903 11.1249 14.7096 10.9314C14.516 10.738 14.2762 10.6412 13.9902 10.6412H9.78832V9.39122H13.9902C14.6178 9.39122 15.1513 9.61087 15.5906 10.0502C16.0301 10.4896 16.2498 11.0232 16.2498 11.6508V14.7912C16.2498 15.6548 15.943 16.3917 15.3294 17.0018C14.7159 17.6118 13.9783 17.9168 13.1167 17.9168H9.01749ZM3.91978 7.1958C3.7552 6.91691 3.62964 6.61872 3.54311 6.30122C3.45658 5.98372 3.41332 5.65691 3.41332 5.3208C3.41332 4.28011 3.77818 3.39497 4.5079 2.66538C5.23749 1.93566 6.12263 1.5708 7.16332 1.5708C8.20388 1.5708 9.08902 1.93566 9.81874 2.66538C10.5483 3.39497 10.9131 4.27976 10.9131 5.31976C10.9131 5.65795 10.8698 5.98545 10.7833 6.30226C10.6968 6.61906 10.5713 6.91691 10.4069 7.1958L9.32999 6.5708C9.4411 6.37636 9.52443 6.17844 9.57999 5.97705C9.63554 5.77566 9.66332 5.55691 9.66332 5.3208C9.66332 4.62636 9.42027 4.03608 8.93415 3.54997C8.44804 3.06386 7.85777 2.8208 7.16332 2.8208C6.46888 2.8208 5.8786 3.06386 5.39249 3.54997C4.90638 4.03608 4.66332 4.62636 4.66332 5.3208C4.66332 5.55691 4.6911 5.77566 4.74665 5.97705C4.80221 6.17844 4.88554 6.37636 4.99665 6.5708L3.91978 7.1958Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceTourIcon);
export default __webpack_public_path__ + "static/media/interface-tour-icon.a544becd43215e4f88c4ce927e70abde.svg";
export { ForwardRef as ReactComponent };